import React, { useEffect } from 'react';
import { styled } from '@linaria/react';
import { Card } from '@daedalus/atlas/Card';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { useInView } from '@daedalus/core/src/_web/utils/browser/hooks/useInView';
import { Offer } from '@daedalus/core/src/offer/types/offer';
import { Room } from '@daedalus/core/src/room/types/room';
import { Footer } from '../Footer';
import { useTrackRoomOfferViewed } from '../Rooms/RoomOffer/useTrackRoomOfferViewed';
const SafeAreaWrapper = /*#__PURE__*/styled('div')({
  name: "SafeAreaWrapper",
  class: "ssldiqj",
  propsAsIs: false
});
type Props = {
  isFooterVisible: boolean;
  offer: Offer;
  room: Room;
};
export const OverlayCompactOfferFooter: React.FC<Props> = ({
  isFooterVisible,
  children,
  offer,
  room
}) => {
  const {
    inView,
    ref
  } = useInView({
    triggerOnce: true,
    threshold: 0.5,
    initialInView: true
  });
  const {
    trackOfferViewed
  } = useTrackRoomOfferViewed({
    offer,
    room
  });
  useEffect(() => {
    if (inView) {
      trackOfferViewed();
    }
  }, [inView, trackOfferViewed]);
  return <div ref={ref}>
      <Footer isFooterVisible={isFooterVisible} position="absolute">
        <Card backgroundColorPath="background.neutral.c000" borderRadius="lg" hasRoundedBottom={false} shadow="fixedReverse">
          <SafeAreaWrapper>
            <ContentWrapper padding="s400">{children}</ContentWrapper>
          </SafeAreaWrapper>
        </Card>
      </Footer>
    </div>;
};

require("./OverlayCompactOfferFooter.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./OverlayCompactOfferFooter.tsx");